export const Variants = {
  CLASSIC: 'classic',
  PLAIN: 'plain',
} as const;
